export const transactions_method_fr = [
  {
    name: "ID",
    width: "5%",
    align: "left",
  },
  {
    name: "UTILISATEUR",
    width: "20%",
    align: "left",
  },
  {
    name: "MÉTHODE",
    width: "10%",
    align: "left",
  },
  {
    name: "TYPE",
    width: "15%",
    align: "left",
  },
  {
    name: "MONTANT",
    width: "15%",
    align: "left",
  },
  {
    name: "STATUT",
    width: "10%",
    align: "center",
  },
  {
    name: "DATE",
    width: "25%",
    align: "center",
  },
];
export const transactions_method_en = [
  {
    name: "ID",
    width: "5%",
    align: "left",
  },
  {
    name: "USER",
    width: "20%",
    align: "left",
  },
  {
    name: "METHOD",
    width: "10%",
    align: "left",
  },
  {
    name: "TYPE",
    width: "15%",
    align: "left",
  },
  {
    name: "AMOUNT",
    width: "15%",
    align: "left",
  },
  {
    name: "STATUS",
    width: "10%",
    align: "center",
  },
  {
    name: "DATE",
    width: "25%",
    align: "center",
  },
];
